import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
const Gallery = () => {
  // Sample images with unique ids and different src/alt values
  const images = [
    { id: 1, src: '/images/ourfleet/8.jpg', alt: 'Image 1' },
    { id: 2, src: '/images/ourfleet/1.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/ourfleet/10.jpg', alt: 'Image 2' },
    { id: 3, src: '/images/ourfleet/2.jpg', alt: 'Image 3' },
    { id: 4, src: '/images/ourfleet/3.jpg', alt: 'Image 4' },
    { id: 5, src: '/images/ourfleet/4.jpg', alt: 'Image 5' },
    { id: 6, src: '/images/ourfleet/5.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/ourfleet/6.jpg', alt: 'Image 6' },

    { id: 6, src: '/images/ourfleet/7.jpg', alt: 'Image 6' },
   
    { id: 6, src: '/images/ourfleet/9.webp', alt: 'Image 6' },

   
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Open modal and set the clicked image
  const openModal = (index) => {
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Show next image in the modal
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Show previous image in the modal
  const prevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (

<>

<section
    className="bg-cover position-relative"
    style={{
      background: 'url(/img/bg-title.jpg) no-repeat',
    }}
    data-overlay="5"
  >
    <div className="container">
      <div className="row align-items-center justify-content-center">
        <div className="col-xl-7 col-lg-9 col-md-12">
          <div className="fpc-capstion text-center my-4">
            <div className="fpc-captions">
              <h1 className="xl-heading text-light">Gallery</h1>
            
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>


    
    <div className="gallery-container ">
      <div className="gallery-grid ">
        {images.map((image, index) => (
          <img
            key={image.id}
            src={image.src}
            alt={image.alt}
            className="gallery-image-item borderr"
            onClick={() => openModal(index)} // Open the modal on click
          />
        ))}
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay">
          <button className="modal-close-button" onClick={closeModal}>
            &times;
          </button>
          <div className="modal-content-container">
            <button className="modal-prev-button" onClick={prevImage}>
              &#10094;
            </button>
            <div className="modal-image-container">
              <img
                src={images[currentImageIndex].src}
                alt={images[currentImageIndex].alt}
                className="modal-image"
              />
            </div>
            <button className="modal-next-button" onClick={nextImage}>
              &#10095;
            </button>
          </div>
        </div>
      )}
    </div>

</>
  );
};

export default Gallery;